import React from "react";

function NotFound() {
    return (
        <div className="text-center my-48 space-y-8">
            <h1 className="text-6xl font-bold">Error 404</h1>
            <h2 className="text-3xl font-bold">Page Not Found</h2>
        </div>
    );
}

export default NotFound;
